<template>
	<div>
		<div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-size-50">
				<md-field>
					<label>ឈ្មោះតំបន់</label>
					<md-input type="text" v-model="zone.name" required @keyup="checkValidation()"></md-input>
				</md-field>
			</div>
			<div class="md-layout-item md-size-50">
				<md-button :class="{'md-raised': true, 'md-primary': isValid}" @click="updateZone()" :disabled="!isValid">
					កែប្រែ</md-button>
			</div>
		</div>
		<md-table>
			<md-table-row>
				<md-table-head>ល.រ</md-table-head>
				<md-table-head>ឈ្មោះទីតាំង</md-table-head>
				<md-table-head>សកម្មភាព</md-table-head>
			</md-table-row>
			<md-table-row v-for="(location, index) in locationList">
				<md-table-cell>{{index+1}}</md-table-cell>
				<md-table-cell>
					{{locationList[index].name}}
				</md-table-cell>

				<md-table-cell>
					<md-button class="md-just-icon md-simple md-danger" @click="deleteLocation(index)">
						<md-icon>delete</md-icon>
						<md-tooltip md-direction="top">លុបចេញ</md-tooltip>
					</md-button>
				</md-table-cell>
			</md-table-row>
			<md-table-row>
				<md-table-cell></md-table-cell>
				<md-table-cell>
					<md-field>
						<label>បញ្ចូលឈ្មោះទីតាំងថ្មី</label>
						<md-input type="text" v-model="newName" @keyup.enter="addLocation()"></md-input>
					</md-field>
				</md-table-cell>

				<md-table-cell>
					<md-button class="md-just-icon md-simple md-success" @click="addLocation()">
						<md-icon>add</md-icon>
						<md-tooltip md-direction="top">ដាក់បញ្ចូល</md-tooltip>
					</md-button>
				</md-table-cell>
			</md-table-row>
		</md-table>
	</div>
</template>

<script>
	export default {
		created() {
			this.getZone();
		},
		mounted() { },
		data() {
			return {
				locationList: [],
				zone: {
					id: "",
					name: "",
				},
				newName: "",
				subcategory: [],
				subValid: {},
				isValid: false,
				list: [],
				order: {}
			}
		},
		methods: {
			getZone() {
				this.$http.get(this.config.api + "/admin/zone/get/single/" + this.$route.params.id).then(data => {
					// this.zoneList = data.body.data
					this.zone = data.body.data.zone
					this.locationList = data.body.data.location

					// for (let i = 0; i < this.zoneList.length; i++) {
					// 	this.newLocationList.push({ new_location: "" });
					// }
				})
			},
			// getCategory() {
			// 	this.$http.get(this.config.api + '/public/category/get/single/' + this.$route.params.id).then(data => {

			// 		this.category.name = data.body.data.category_name.split("||")[0]
			// 		this.category.khmer_name = data.body.data.category_name.split("||")[1]
			// 		this.category.category_id = data.body.data.category_id
			// 		this.category.picture = data.body.data.category_picture
			// 		// this.subcategory = data.body.data.subcategory
			// 		let subcategory = data.body.data.subcategory;
			// 		this.subcategory = [];
			// 		for (let i = 0; i < subcategory.length; i++) {
			// 			this.subcategory.push({
			// 				isValid: false,
			// 				category_id: data.body.data.category_id,
			// 				tag_name: subcategory[i].tag_name.split('||')[0],
			// 				tag_khmer_name: subcategory[i].tag_name.split('||')[1],
			// 				tag_id: subcategory[i].tag_id
			// 			})
			// 		}
			// 	})
			// },
			addLocation() {
				let name = this.newName;
				if (String(name).length > 1) {
					this.$http.post(this.config.api + "/admin/zone/new_location", {
						zone_id: this.zone.id,
						name: name
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "ទីតាំងត្រូវបានបង្កើតដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.getZone();
						}
					})
				}
			},
			updateZone() {
				this.$http.post(this.config.api + "/admin/zone/update_zone", {
					zone_id: this.zone.id,
					zone_name: this.zone.name,
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "ឈ្មោះតំបន់ត្រូវបានកែប្រែដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getZone();
						this.isValid = false;
					}
				})
			},
			// updateSubcategory(id) {
			// 	let name = this.subcategory[id].tag_name + "||" + this.subcategory[id].tag_khmer_name
			// 	let tag_id = this.subcategory[id].tag_id
			// 	let category_id = this.subcategory[id].category_id

			// 	this.$http.post(this.config.api + "/admin/category/update_subcategory", {
			// 		tag_id,
			// 		name,
			// 		category_id
			// 	}).then(res => {
			// 		if (res.body.status == 'success') {
			// 			this.tabName = 'first'
			// 			this.$notification.notify({
			// 				message: "Subcategory was updated successfully.",
			// 				icon: 'done',
			// 				type: 'success'
			// 			})
			// 			this.getCategory();
			// 		}
			// 	})
			// },
			deleteLocation(index) {
				this.$http.post(this.config.api + "/admin/zone/delete_location", {
					location_id: this.locationList[index].id
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "ទីតាំងត្រូវបានលុបដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getZone();
					}
				})
			},
			// checkSubValidation(id, select = false) {

			// 	if (select && this.subcategory[id].category_id == this.category.category_id) {
			// 		this.subcategory[id].isValid = false;
			// 	} else {
			// 		this.subcategory[id].isValid = true;
			// 	}

			// },
			checkValidation() {

				if (this.zone.name.length > 2) {
					this.isValid = true;
				} else {
					this.isValid = false;
				}
			},
			clear() {

			}
		}
	}
</script>

<style>
	.grid-8 {
		text-align: center;
		max-width: 12.5%;
		min-width: 12.5%;
		flex: 0 0 12.5%;
	}

	.thumb-product {
		width: 100%;
	}

	.product-thumbnail {
		width: 100px;
		height: 100px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Zones/Edit.vue